import React, { useEffect,useState} from 'react';
import './Layout.css'; // Updated to match the CSS file
import { Menu, Container, Image,Segment  } from 'semantic-ui-react';
import logoUrl from '../Images/MicroconFooterLogo.png'
import { getLastModifiedDate  } from '../api/LastModifyVersion';

interface LayoutProps {
    children?: React.ReactNode;
    user?: string;
}

const Layout: React.FC<LayoutProps> = ({ children = null, user = "Guest User" }: LayoutProps) => {
    const [lastModifiedDate, setLastModifiedDate] = useState<string | null>(null);

    useEffect(() => {
        async function loadLastModifiedDate() {
            try {
                const date = await getLastModifiedDate();
                setLastModifiedDate(date);
            } catch (error) {
                console.error('Failed to fetch last modified date:', error);
            }
        }

        loadLastModifiedDate();
    }, []);




 return (
        <>
            {/* Header */}
            <Menu inverted fluid id='header'>
                <Container>                   

                    <Menu.Menu style={{ width: '100%', justifyContent: 'center' }}>
                        <Menu.Item style={{justifyContent: 'center' }}>
                            <h2>Welcome to MEB Cloud</h2>
                                 <div
                                  className="version"
                                  style={{
                                    position: 'fixed',
                                    bottom: '0',
                                    width: '100%',
                                    textAlign: 'center',
                                    color: '#666',
                                    fontSize: '12px',
                                    backgroundColor: '#f9f9f9',
                                    padding: '10px 0',
                                    borderTop: '1px solid #e0e0e0',
                                  }}
                                >
                                  Version: {lastModifiedDate}
                                </div>
                        </Menu.Item>
                    </Menu.Menu>                    
                </Container>
            </Menu>

            {/* Main Content */}
            <Container className="container">
                {children}
            </Container>

            <Menu inverted fluid id='footer'>
                <Container>                                                      
                </Container>
            </Menu>
        </>
    );
}

export default Layout;
